import { eventPointNative } from './eventPoint.js';
import { TOOLTIP_POSITION_DEFAULT_RETURN } from '../components/TooltipWrapper/constants.js';

function getVerticalBarChartTooltipPosition({
  chartXPosition,
  formatPositionForTooltip,
  maxIndex,
  step,
  tooltipPosition,
  yMax,
  yMin
}) {
  const {
    event,
    index,
    eventType
  } = tooltipPosition;

  if (eventType === 'mouse' && event) {
    const point = eventPointNative(event);

    if (point == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }

    const {
      svgX,
      svgY
    } = point;
    const currentPoint = svgX - chartXPosition;
    const activeIndex = Math.floor(currentPoint / step);

    if (activeIndex < 0 || activeIndex > maxIndex || svgY <= yMin || svgY > yMax) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }

    return formatPositionForTooltip(activeIndex);
  } else if (index != null) {
    return formatPositionForTooltip(index);
  }

  return TOOLTIP_POSITION_DEFAULT_RETURN;
}

export { getVerticalBarChartTooltipPosition };
